import { ChromeAppResponse } from 'Environment/ChromeApp/types';
import { LeasingProperties } from 'Workspace/ChromeApp/ChromeAppCustomerConfiguration';

export const getDefaultLeasingProperties = (): LeasingProperties => {
	return {
		alwaysBypassAuthForCachedResources: false,
		bypassAuthForCachedResources: false,
		telemetryHeadlessLaunchEnabled: false,
		telemetryLaunchMinTimeIntervalMins: 720,
		telemetryLaunchShadowDelayMins: 1,
	};
};

export const parseLeasingPropertiesFromResponse = (response: ChromeAppResponse) => {
	const leasingProperties = response?.result?.leasingProperties;
	return leasingProperties
		? { ...getDefaultLeasingProperties(), ...leasingProperties }
		: null;
};
